import {
  sidebarTemplate,
  sidebarMenuContainerSelector
} from './sidebar-templates';
import { emptyElement } from '../../utils/utils';
import Menu from '../menu/menu';
import styles from './sidebar.css';

class Sidebar {
  constructor(selector, { desktopSidebarIsToggleable = false } = {}) {
    const node = document.querySelector(selector);
    // default close
    this.closed = true;
    this.desktopSidebarIsToggleable = desktopSidebarIsToggleable;
    if (node) {
      this.node = node;
    } else {
      console.error(
        `element, ${selector}, should exist for Common Header to work properly`,
      );
    }
  }

  toggleOpen = () => {
    this.closed = !this.closed;
    // eslint-disable-next-line no-unused-expressions
    this.closed
      ? this.rootElement.classList.add(styles.closed)
      : this.rootElement.classList.remove(styles.closed);
  };

  set globalMenu(x) {
    this.menu.globalMenu = x;
    this.menu.isGlobalMenuOpen = false;
  }

  set contextMenu(x) {
    this.menu.contextMenu = x;
  }

  set greeting(x) {
    this.menu.greeting = x;
  }

  set isEclientLink(x) {
    this.menu.isEclientLink = x;
  }

  render() {
    emptyElement(this.node);
    const frag = document.createRange().createContextualFragment(
      sidebarTemplate({
        desktopSidebarIsToggleable: this.desktopSidebarIsToggleable,
        closed: this.closed
      }),
    );
    this.node.appendChild(frag);
    this.node
      .querySelector(`.${styles.overlay}`)
      .addEventListener('click', this.toggleOpen);
    this.rootElement = Array.prototype.slice.call(this.node.children).shift();
    this.menu = new Menu(sidebarMenuContainerSelector);
    this.menu.render();
  }
}

export default Sidebar;
